/*
  Flickity hides off-screen carousel cells with aria-hidden="true" but leaves the
  product links and "Add to cart" buttons inside them in the tab order. Keyboard
  users then land on controls that screen readers are told to ignore — axe flags
  this as "[aria-hidden='true'] elements contain focusable descendents".

  This mirrors each cell's aria-hidden state onto the tabindex of its focusable
  descendants: a hidden cell drops out of the tab order, a selected cell gets its
  original tabindex back. Pointer interaction is deliberately left alone (no
  `inert`), so a cell that is still half-visible mid-transition stays clickable.

  Works for every Flickity instance on the page — the section carousels, the
  ingredients slider, recommended products — because it keys off the
  .flickity-slider > cell structure rather than any one section's markup.
*/
(function () {
  'use strict';

  var FOCUSABLE = [
    'a[href]',
    'area[href]',
    'button',
    'input',
    'select',
    'textarea',
    'iframe',
    'object',
    'embed',
    'summary',
    'audio[controls]',
    'video[controls]',
    '[contenteditable="true"]',
    '[tabindex]'
  ].join(', ');

  function isCell(node) {
    return (
      node &&
      node.nodeType === 1 &&
      node.parentElement &&
      node.parentElement.classList.contains('flickity-slider')
    );
  }

  function syncCell(cell) {
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    var nodes = cell.querySelectorAll(FOCUSABLE);

    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];

      if (hidden) {
        // Remember what the markup asked for so it can be handed back verbatim.
        if (typeof el.dataset.carouselTabindex === 'undefined') {
          el.dataset.carouselTabindex = el.hasAttribute('tabindex')
            ? el.getAttribute('tabindex')
            : '';
        }
        el.setAttribute('tabindex', '-1');
      } else if (typeof el.dataset.carouselTabindex !== 'undefined') {
        var original = el.dataset.carouselTabindex;
        if (original === '') {
          el.removeAttribute('tabindex');
        } else {
          el.setAttribute('tabindex', original);
        }
        delete el.dataset.carouselTabindex;
      }
    }
  }

  function sweep() {
    var cells = document.querySelectorAll('.flickity-slider > *');
    for (var i = 0; i < cells.length; i++) {
      syncCell(cells[i]);
    }
  }

  var sweepQueued = false;
  function queueSweep() {
    if (sweepQueued) return;
    sweepQueued = true;
    requestAnimationFrame(function () {
      sweepQueued = false;
      sweep();
    });
  }

  function addsACarousel(mutation) {
    for (var i = 0; i < mutation.addedNodes.length; i++) {
      var node = mutation.addedNodes[i];
      if (node.nodeType !== 1) continue;
      if (
        isCell(node) ||
        node.classList.contains('flickity-slider') ||
        node.querySelector('.flickity-slider')
      ) {
        return true;
      }
    }
    return false;
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];

      if (mutation.type === 'attributes') {
        if (isCell(mutation.target)) syncCell(mutation.target);
      } else if (addsACarousel(mutation)) {
        // Flickity moves cells into .flickity-slider with aria-hidden already
        // set, so no attribute mutation fires for them — sweep instead.
        queueSweep();
      }
    }
  });

  observer.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['aria-hidden']
  });

  sweep();
  window.addEventListener('load', sweep);
})();
